import React from 'react';
import { useNavigate } from 'react-router-dom';

const ServiceCard = ({ service }) => {
  const navigate = useNavigate();

  const costColors = {
    free: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    'low-cost': 'bg-blue-100 text-blue-800 border-blue-200',
    paid: 'bg-gray-100 text-gray-800 border-gray-200'
  };

  return (
    <div
      className="card cursor-pointer group"
      onClick={() => navigate(`/service/${service.id}`)}
      data-testid="service-card"
    >
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors flex-1" data-testid="service-card-name">
          {service.name}
        </h3>
        <span
          className={`px-4 py-1.5 rounded-full text-sm font-semibold border ${costColors[service.cost] || costColors.paid}`}
          data-testid="service-card-cost"
        >
          {service.cost}
        </span>
      </div>

      <p className="text-gray-600 text-base mb-5 line-clamp-2 leading-relaxed" data-testid="service-card-description">
        {service.description}
      </p>

      <div className="space-y-3 mb-5">
        <div className="flex items-center text-base text-gray-700">
          <span className="mr-3 text-xl">\ud83d\udccd</span>
          <span data-testid="service-card-location" className="font-medium">
            {service.city}, {service.state}
          </span>
        </div>

        <div className="flex items-center text-base text-gray-700">
          <span className="mr-3 text-xl">\ud83d\udcde</span>
          <span data-testid="service-card-phone" className="font-medium">{service.contact_phone}</span>
        </div>

        <div className="flex items-center text-base text-gray-700">
          <span className="mr-3 text-xl">\ud83d\udd50</span>
          <span data-testid="service-card-hours" className="font-medium">{service.availability_hours}</span>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-4">
        {service.service_types.slice(0, 2).map((type, index) => (
          <span
            key={index}
            className="bg-teal-50 text-teal-700 px-3 py-1 rounded-lg text-sm font-medium border border-teal-200"
            data-testid="service-card-type"
          >
            {type}
          </span>
        ))}
        {service.service_types.length > 2 && (
          <span className="text-sm text-gray-500 font-medium">+{service.service_types.length - 2} more</span>
        )}
      </div>

      {service.mode && service.mode.length > 0 && (
        <div className="flex gap-2 pt-3 border-t border-gray-100">
          {service.mode.includes('online') && (
            <span className="bg-purple-50 text-purple-700 px-3 py-1 rounded-lg text-sm font-medium border border-purple-200" data-testid="service-card-mode-online">
              \ud83d\udcbb Online
            </span>
          )}
          {service.mode.includes('in-person') && (
            <span className="bg-orange-50 text-orange-700 px-3 py-1 rounded-lg text-sm font-medium border border-orange-200" data-testid="service-card-mode-in-person">
              \ud83c\udfe5 In-person
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default ServiceCard;
